import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import React from "react";
import Navbar from "./components/Navbar";
import TopBanner from "./components/TopBanner";
import AboutCompany from "./components/AboutCompany";
import AboutUs from "./components/AboutUs";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import DevTools from "./components/DevTools";
// import NewsSection from "./components/NewsSection";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsCondition from "./components/TermsCondition";
import Message from "./components/Message";
import CorporatePhilosophy from "./components/CorporatePhilosophy";
import ManagementPolicy from "./components/ManagementPolicy";
import ServicesSection from "./components/ServicesSection";
import BusinessEthics from "./components/BusinessEthics";
import Industries from "./components/Industries";
import Solutions from "./components/Solutions";
import IndustriesSection from "./components/IndustriesSection";
import SolutionsSection from "./components/SolutionsSection";

function AppContent() {
  const location = useLocation();

  // Check if the current route is "/" or "/home"
  const isHomePage = location.pathname === "/" || location.pathname === "/home";

  return (
    <div className="h-full w-full bg-black pt-20">
      <Navbar />

      {/* Show these components ONLY on "/" or "/home" */}
      {isHomePage && (
        <>
          <TopBanner />
          <AboutCompany />
          <DevTools />
          <ServicesSection />
          <IndustriesSection />
          <SolutionsSection />
          {/* <NewsSection /> */}
        </>
      )}

      <Routes>
        <Route path="/about/company-profile" element={<AboutUs />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termscondition" element={<TermsCondition />} />
        <Route path="/about/message" element={<Message />} />
        <Route path="/about/corporatephilosophy" element={<CorporatePhilosophy />} />
        <Route path="/managementpolicy" element={<ManagementPolicy />} />
        <Route path="/businessethics" element={<BusinessEthics />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/thank-you" element={<h1 className="text-center text-3xl mt-10">Thank You!</h1>} />
      </Routes>

      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;